<template>
  <div class="stripe stripe--card">
    <div
      ref="element"
      class="card-element"
    />
    <transition name="slide-down">
      <p
        v-if="errorMessage"
        class="form__error"
      >
        {{ errorMessage }}
      </p>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    stripeKey: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  data() {
    // eslint-disable-next-line
    const stripe = Stripe(this.stripeKey);
    return {
      stripe,
      card: stripe.elements().create('card', this.options),
      event: null,
      tokenEvent: null,
    };
  },
  computed: {
    errorMessage() {
      if (this.event && this.event.error) {
        return this.event.error.message;
      }
      if (this.tokenEvent && this.tokenEvent.error) {
        return this.tokenEvent.error.message;
      }
      if (
        this.tokenEvent?.token?.card?.funding === 'prepaid'
        && !this.$store.state.delayPrepaidCardValidation
      ) {
        return this.$t('error-prepaid-card');
      }
      return null;
    },
  },
  mounted() {
    this.card.mount(this.$refs.element);
    this.card.on('change', this.change);
  },
  methods: {
    change(event) {
      this.event = event;
      this.tokenEvent = null;
      this.$emit('change', event);
      if (event.complete) {
        this.stripe.createToken(this.card).then((tokenEvent) => {
          this.tokenEvent = tokenEvent;
          if (tokenEvent?.token
            && (tokenEvent.token?.card?.funding !== 'prepaid' || this.$store.state.delayPrepaidCardValidation)) {
            this.$emit('token', tokenEvent.token);
          }
        });
      }
    },
  },
};
</script>
